/* eslint-disable */
import { Box, Typography, Stack, Button, Checkbox as MuiCheckbox, TextField } from '@mui/material'
import colors from '../../constants/colors'
import selectOptions from '../../constants/selectOptions'
import CardAction from '../CardAction'
import CardTAG from '../CardTAG'
import FormLayout from '../forms/FormLayout'
import TableTAG from '../TableTAG'
import AddIcon from '@mui/icons-material/Add'
import { useForm } from 'react-hook-form'
import ModalTAG from '../ModalTAG'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { INewUser } from '../forms/AddUserForm/types'
import { addNewUser, getOrganizationUsers } from '../../store/users/usersSlice'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, store } from '../../store'
import TextareaInput from '../TextareaInput'
import { formTypes, ICaseOverviewForm, ICaseStatusMessage, reportPatchProperties } from './types'
import constants from './constants'
import {
  findItemByUuid,
  formValidation,
  getIdsFromUsers,
  makeid,
  oshaQuestionParser,
  resolveNumberOfChangesString,
  transformStructure,
  updateAnswersOptions,
  updateAnswersText,
} from './utils'
import { vestResolver } from '@hookform/resolvers/vest'
import DividerTAG from '../DividerTAG'
import AddPersonForm from '../forms/AddPersonForm'
import ReportingPartyForm from '../forms/ReportingPartyForm'
import CaseTypeForm from '../forms/CaseTypeForm'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import timeUtils from '../../utils/timeUtils'
import reportsSelectors from '../../store/reports/reportsSelectors'
import useCallbackPrompt from '../../hooks/useCallbackPrompt'
import { addChange } from '../../store/changes/changesSlice'
import { getReportTeam, postCaseStatusMessage } from '../../store/reports/reportsSlice'
import usersSelectors from '../../store/users/usersSelectors'
import SearchInput from '../SearchInput'
import { IUserProfile } from '../../pages/UsersPage/constants'
import { columns } from '../forms/ImmediateItentionForm'
import usersService from '../../services/usersService'
import reportsService from '../../services/reportsService'
import {
  IReportingPartyDTO,
  ISubjectDTO,
  IVictimDTO,
  usersReportRoles,
} from '../../store/users/types'
import ReportingPartyConstants from '../forms/ReportingPartyForm/constants'
import { IQuestionV2, MainObject } from '../../store/reports/types'
import questionsAnswersUtils from '../../utils/questionsAnswersUtils'
import SubmitCancelButtons from '../SubmitCancelButtons'
import _ from 'lodash'
import { diff } from 'deep-diff'
import RemoveButton from '../RemoveButton'
import authSelectors from '../../store/auth/authSelectors'
import { useLocation } from 'react-router-dom'
import { usersReportAccess } from '../../store/auth/userTypes'
import classnames from 'classnames'
import SelectOneForm from '../forms/SelectOneForm'
import caseOverviewConstants  from '../CaseOverview/constants'
import { updateSelectedReportCaseTypes, clearCaseTypeQuestions } from '../../store/reports/reportsSlice'
import { error, success } from '../../utils/alertUtils';


const DataPart: React.FC = () => {
  const [openUserModal, setOpenUserModal] = useState(false)
  const [changes, setChanges] = useState(0)
  const [openModalAreYouSure, setOpenModalAreYouSure] = useState(false)
  const [numberOfChanges, setNumberOfChanges] = useState(0)
  const [searchUser, setSearchUser] = useState<string>('')
  const [caseStatusMessages, setCaseStatusMessages] = useState<ICaseStatusMessage[]>([])
  const [selectedUsers, setSelectedUsers] = useState<any>({})
  const [teamMembersToRemove, setTeamMembersToRemove] = useState<number[]>([])
  const [haveWeScrolledDowntoQuestion, setHaveWeScrolledDowntoQuestion] = useState<boolean>(false)
  const [haveQuestionsBeenRendered, setHaveQuestionsBeenRendered] = useState<boolean>(false)
  const [oshaAnswersUpdated, setOshaAnswersUpdated] = useState<boolean>(false)
  // const [canEdit, setCanEdit] = useState<boolean>(false);
  const selectedReport = useSelector(reportsSelectors.selectedReport)
  const teamMembers = useSelector(usersSelectors.teamMembers)
  const organizationUsers = useSelector(usersSelectors.organizationUsers)
  const userEditAccess = useSelector(authSelectors.userReportEditAccess)
  const getUsers = async () => {
    dispatch(getOrganizationUsers({ searchValue: searchUser, excludeLoggedUser: true, onlyAssignable: false}))
  }

  const dispatch = useDispatch<AppDispatch>()

  // --- helpers ---
  const norm = (s?: string) => (s || '').trim().toLowerCase();


  // --- helpers (keep norm above) ---
  const toReportingPartyDTO = (r: any): IReportingPartyDTO => {
    const src = r?.reporting_party ? r.reporting_party : r;
    return {
      reporting_party: {
        person_type: src?.person_type,
        full_name: src?.full_name,
        description: src?.description,
        image: src?.image ?? null,
        report: src?.report,
      },
      custom_fields: r?.custom_fields ?? src?.custom_fields,
      id: r?.id ?? src?.id,
    };
  };
  // Clear all reporter forms, then rebuild from a list
  const refreshReportingPartyForms = (list: any[]) => {
    setReportingPartyFunctions({});
    setReportingPartyCount(0);
    setTrackReportingPartyChanges({});
    setReportersToRemove([]);
    list.forEach(r => addReportingPartyFormHandler(toReportingPartyDTO(r)));
  };

  const reloadReportersFromServer = async (reportId: number) => {
    const res = await reportsService.getCaseById(reportId);
    const latestReporters = (res?.reporters ?? []).map(toReportingPartyDTO);
    refreshReportingPartyForms(latestReporters);
  };

  const toVictimDTO = (v: any): IVictimDTO => {
    const src = v?.victim ? v.victim : v;
    return {
      victim: {
        person_type: src?.person_type,
        full_name: src?.full_name,
        description: src?.description,
        image: src?.image ?? null,
        report: src?.report,
      },
      custom_fields: v?.custom_fields ?? src?.custom_fields,
      id: v?.id ?? src?.id,
    };
  };
  
  const toSubjectDTO = (s: any): ISubjectDTO => {
    const src = s?.subject ? s.subject : s;
    return {
      subject: {
        person_type: src?.person_type,
        full_name: src?.full_name,
        description: src?.description,
        image: src?.image ?? null,
        report: src?.report,
      },
      custom_fields: s?.custom_fields ?? src?.custom_fields,
      id: s?.id ?? src?.id,
    };
  };

  // Clear all subject forms, then rebuild from a list
  const refreshSubjectForms = (list: any[]) => {
    setSubjectFunction({});
    setSubjectCount(0);
    setTrackSubjectChanges({});
    setSubjectsToRemove([]);
    list.forEach(s => addPersonFormHandler(toSubjectDTO(s)));
  };

  const reloadSubjectsFromServer = async (reportId: number) => {
    const res = await reportsService.getCaseById(reportId);
    const latestSubjects = (res?.subjects ?? []).map(toSubjectDTO);

    refreshSubjectForms(latestSubjects);
  };

  const reloadVictimsFromServer = async (reportId: number) => {
    console.log(reportId);
    const res = await reportsService.getCaseById(reportId); 
    const latestVictims = (res?.victims ?? []).map(toVictimDTO);
    refreshVictimForms(latestVictims);
  };
  const refreshVictimForms = (list: any[]) => {
    setVictimsFunction({});
    setVictimsCount(0);
    setTrackVictimsChanges({});
    setVictimsToRemove([]);

    list.forEach(v => addVictimFormHandler(toVictimDTO(v)));
  };

  // // Dedupe by id, then by name (case-insensitive)
  // const dedupeVictims = (arr: any[]) => {
  //   const byId = new Map<number, any>();
  //   const byName = new Map<string, any>();

  //   for (const v of arr) {
  //     if (v?.id) {
  //       byId.set(v.id, v);
  //     } else if (v?.full_name) {
  //       const k = norm(v.full_name);
  //       if (!byName.has(k)) byName.set(k, v);
  //     }
  //   }
  //   return [...byId.values(), ...byName.values()];
  // };


  // useEffect(() => {
  //   setCanEdit(userEditAccess);
  //   // console.log('userEditAccess', userEditAccess)
  // }, [userEditAccess]);

  const getMessages = async () => {
    const { data } = await reportsService?.getCaseStatusMessages(selectedReport?.id as number)
    setCaseStatusMessages(data)
  }

  const onSearchValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchUser(e.target.value)
  }

  const handleUsersSelect = (data: IUserProfile) => {
    const indexOfObject = Object.keys(selectedUsers)?.find(key => +key === data.user.id)

    if (selectedUsers?.length !== 0 && indexOfObject && +indexOfObject !== -1) {
      const reducedArray = [...selectedUsers]
      reducedArray.splice(+indexOfObject, 1)
      setSelectedUsers(reducedArray)
      setValue('teamMembers', reducedArray, { shouldDirty: true })
      return
    }
    let newTeamMembersObject: { [key: number]: any } = {}
    Object.keys(selectedUsers)?.forEach(key => {
      newTeamMembersObject[selectedUsers[key]?.id] = selectedUsers[key]
    })
    newTeamMembersObject[data?.id] = data
    setValue('teamMembers', newTeamMembersObject, { shouldDirty: true })
    setSelectedUsers(newTeamMembersObject)
  }

  const removeUserFromTeam = (userId: number) => {
    //check if it is 'LEAD_INVESTIGATOR
    if (selectedUsers[userId]?.case_role === usersReportRoles.LEAD_INVESTIGATOR) {
      // LEAD_INVESTIGATOR cannot be removed from team, don't do anything for now
      return
    }
    // assign to the key 'userId'  variable _ indicating it will be unused
    const { [userId]: _, ...updatedUsers } = selectedUsers
    setValue('teamMembers', updatedUsers, { shouldDirty: true })
    setSelectedUsers(updatedUsers)
    setTeamMembersToRemove(prev => [...prev, selectedUsers[userId]?.reportAssingId])
  }
  
  const saveEditsLogic = async () => {
    let finalResponse = {}

    const { answersToUpdate = [], newAnswers = [] } = oshaAnswers.reduce(
        (acc: { answersToUpdate: MainObject[]; newAnswers: MainObject[] }, answer: MainObject) => {
          if (answer?.id) {
            if (answer?.subanswers?.length > 0) {
              const answersNew = answer.subanswers.filter(subanswer => !!!subanswer?.id)
              if (answersNew?.length > 0) {
                acc.newAnswers.push({ ...answer, subanswers: answersNew })
              }
              answer.subanswers = answer.subanswers.filter(subanswer => !!subanswer?.id)
            }
            acc.answersToUpdate.push(answer)
          } else {
            acc.newAnswers.push(answer)
          }
          return acc
        },
        { answersToUpdate: [], newAnswers: [] },
    )

    if (oshaChangesCount.current > 0) {
      const reportId = selectedReport?.id as number

      if (!updateOshaAnswers) {
        await reportsService.postAnswersToCaseTypeQuestions(reportId, oshaAnswers, 'osha')
      } else {
        const formattedOshaAnswers =
            questionsAnswersUtils.removeQuestionPropertyFromObjects(answersToUpdate)

        await Promise.all([
          reportsService.patchAnswers(reportId, formattedOshaAnswers),
          reportsService.postAnswersToCaseTypeQuestions(reportId, newAnswers, 'osha'),
        ])
      }
    }

    const oshaTypeValues = functionsObject.submitOshaViolenceType() as any
    const selectedType = oshaTypeValues?.osha
    if (selectedType && caseOverviewConstants.oshaTypeToOptionId[selectedType] !== undefined) {
      const optionId = caseOverviewConstants.oshaTypeToOptionId[selectedType]
      const reportId = selectedReport?.id as number
      const violenceTypeAnswer = findItemByUuid(oshaAnswers, caseOverviewConstants.oshaViolenceTypeQuestionUuid)
      const questionId = violenceTypeAnswer?.answer?.question
      if (!questionId) return
      const currentOptionId = violenceTypeAnswer?.options?.[0]
      if (currentOptionId !== optionId) {
        if (violenceTypeAnswer?.id) {
          await reportsService.patchAnswers(reportId, [{ ...violenceTypeAnswer, options: [optionId] }])
        } else {
          await reportsService.postAnswersToCaseTypeQuestions(reportId, [{
            uuid: caseOverviewConstants.oshaViolenceTypeQuestionUuid,
            options: [optionId],
            answer: { question: questionId, text: '' },
            subanswers: [],
          }], 'osha')
        }
      }
    }

    const reloadCaseTypesFromServer = async (reportId: number) => {
      try {
        const res = await reportsService.getCaseById(reportId)
        const latestCaseTypes = res?.types ?? []

        // Update redux state for selectedReport with fresh case types
        dispatch(updateSelectedReportCaseTypes(latestCaseTypes))
        dispatch(clearCaseTypeQuestions());
      } catch (err) {
        error('Error while reloading case types')
      }
    }

    // check if summary, tier_level, attorney, name is in dirty values
    const { summary, tier_level, attorney, name } = getValues()
    const dirtyKeys = Object.keys(formState.dirtyFields)
    const caseTypeData = functionsObject.submitCaseTypes() as any
    
    if (
        dirtyKeys?.some(key =>
            Object.values(reportPatchProperties).includes(key as reportPatchProperties),
        ) ||
        caseTypeData
    ) {
      
      caseTypeData.push(15)
      await reportsService?.patchReport({
        selectedReportId: selectedReport?.id as number,
        dataBody: { types: caseTypeData, summary, tier_level, attorney, name },
      })
      // 🔑 Refresh case types in Redux immediately
      await reloadCaseTypesFromServer(selectedReport!.id)
    }

    finalResponse = { caseTypes: caseTypeData }
    finalResponse = { ...finalResponse, ...getValues() }

    // const subjects = []
    // for (const key in subjectsFunctions) {
    //   if (subjectsFunctions[key].submitFunction() !== undefined)
    //     subjects.push(subjectsFunctions[key].submitFunction())
    // }

    // if (subjects.length > 0) {
    //   const subjectsPromises = subjects.map(subject => {
    //     subject.subject.report = selectedReport?.id as number
    //     return subject.id
    //         ? usersService.patchSubject(subject)
    //         : usersService.postNewSubject(subject)
    //   })

    //   try {
    //     const addedSubjects = await Promise.all(subjectsPromises)
    //     success('Subjects added successfully');
    //     // console.log('Successfully added Subjects', addedSubjects)
    //   } catch (err) {
    //     error('Error while adding Subjects');
    //     // console.error('Sotmething went wrong while adding Subjects', err)
    //   }
    // }

    const subjects: ISubjectDTO[] = [];
    for (const key in subjectsFunctions) {
      const dto = subjectsFunctions[key]?.submitFunction?.();
      if (dto) subjects.push(dto);
    }

    if (subjects.length > 0) {
      // attach report id, strip undefined image
      subjects.forEach(s => {
        s.subject.report = selectedReport?.id as number;
        if (s.subject.image === undefined) delete s.subject.image;
      });

      try {
        // (optional) delete removed first
        // if (subjectsToRemove?.length) {
        //   await Promise.all(subjectsToRemove.map(id => usersService.deleteSubject(`${id}`)));
        // }

        // upsert new/edited
        if (subjects.length) {
          await Promise.all(
            subjects.map(s => (s?.id ? usersService.patchSubject(s) : usersService.postNewSubject(s)))
          );
        }

        success('Subject changes saved');

        // reload fresh list so the last-added appears immediatelycaseTypeData
        await reloadSubjectsFromServer(selectedReport!.id);

        // reset the Save badge/counter for this batch
        if (typeof numberOfChanges === 'number' && numberOfChanges > 0) {
          updateNumberOfChanges(-numberOfChanges);
        }
      } catch (err) {
        error('Error while saving Subjects');
      }
    }

    if (subjectsToRemove.length > 0) {
      const deleteSubjectsPromises = subjectsToRemove.map(id => usersService.deleteSubject(`${id}`))
      try {
        const deletedSubjects = await Promise.all(deleteSubjectsPromises)
        success('Subjects deleted successfully');
      } catch (err) {
        error('Error while deleting Subjects');
      }
    }

    // const victims = []
    // for (const key in victimsFunctions) {
    //   if (victimsFunctions[key].submitFunction() !== undefined)
    //     victims.push(victimsFunctions[key].submitFunction())
    // }
    // if (victims?.length > 0) {
    //   const victimPromises = victims?.map((victim: IVictimDTO) => {
    //     victim.victim.report = selectedReport?.id as number
    //     return victim?.id ? usersService.patchVictim(victim) : usersService.postNewVictim(victim)
    //   })

    //   try {
    //     const addedVictims = await Promise.all(victimPromises)
    //     success('Victim added successfully')
    //     reset()
    //     // console.log('Successfully added Victim', addedVictims)
    //   } catch (err) {
    //     error('Error while adding Victim');
    //     // console.error('Sotmething went wrong while adding Victim', err)
    //   }
    // }
    // collect current form payloads (call submitFunction ONCE)
    // --- VICTIMS SAVE START ---
    const victims: IVictimDTO[] = [];
    for (const key in victimsFunctions) {
      const dto = victimsFunctions[key]?.submitFunction?.();
      if (dto) victims.push(dto);
    }

    if (victims.length > 0) {
      victims.forEach(v => {
        v.victim.report = selectedReport?.id as number;
        if (v.victim.image === undefined) delete v.victim.image;
      });

      try {
        // 1) delete removed
        // if (victimsToRemove?.length) {
        //   await Promise.all(victimsToRemove.map((id: number) => usersService.deleteVictim(`${id}`)));
        // }

        // 2) upsert new/edited
        if (victims.length) {
          await Promise.all(
            victims.map(v => (v?.id ? usersService.patchVictim(v) : usersService.postNewVictim(v)))
          );
        }

        success('Victim changes saved');

        // 3) reload from server so last-added shows for sure
        await reloadVictimsFromServer(selectedReport!.id);

        // 4) reset the Save badge/counter
        if (typeof numberOfChanges === 'number' && numberOfChanges > 0) {
          updateNumberOfChanges(-numberOfChanges);
        }
      } catch (err) {
        error('Error while saving Victims');
      }
    }
    // --- VICTIMS SAVE END ---



    if (victimsToRemove?.length) {
      const deleteVictimsPromisses = victimsToRemove?.map((id: number) => {
        return usersService.deleteVictim(`${id}`)
      })

      try {
        const deletedVictims = await Promise.all(deleteVictimsPromisses)
        success('Victim deleted successfully');
      } catch (err) {
        error('Error deleting Victim');
      }
    }

    // const reportingParties = []
    // for (const key in reportingPartyFunctions) {
    //   if (reportingPartyFunctions[key].submitFunction())
    //     reportingParties.push(reportingPartyFunctions[key].submitFunction())
    // }

    // const reportingPartiesPromises = reportingParties?.map((reportingParty: IReportingPartyDTO) => {
    //   reportingParty.reporting_party.report = selectedReport?.id as number
    //   return usersService.postNewReportingParty(reportingParty)
    // })

    // if (reportingPartiesPromises.length > 0) {
    //   try {
    //     const addedReporters = await Promise.all(reportingPartiesPromises)
    //     success('Reporting party added successfully');
    //     // console.log('Successfully added reporting parties', addedReporters)
    //   } catch (err) {
    //     error('Error while adding reporting parties');
    //     // console.error('Sotmething went wrong while adding reporting parties', err)
    //   }
    // }


    // if (reportersToRemove?.length) {
    //   const deleteReportersPromises = reportersToRemove?.map((id: number) => {
    //     return usersService.deleteReporter(`${id}`)
    //   })

    //   try {
    //     const deletedReporters = await Promise.all(deleteReportersPromises)
    //     success('Reporters deleted successfully')
    //     // console.log('Successfully deleted reporters', deletedReporters)
    //   } catch (err) {
    //     error('Error while deleting reporters');
    //     // console.error('Sotmething went wrong while deleting reporters', err)
    //   }
    // }

    const reportingParties: IReportingPartyDTO[] = [];
    for (const key in reportingPartyFunctions) {
      const dto = reportingPartyFunctions[key]?.submitFunction?.();
      if (dto) reportingParties.push(dto);
    }

    if (reportingParties.length > 0) {
      reportingParties.forEach(rp => {
        rp.reporting_party.report = selectedReport?.id as number;
        if (rp.reporting_party.image === undefined) delete rp.reporting_party.image;
      });

      try {
        await Promise.all(
          reportingParties.map(rp =>
            rp?.id
              ? usersService.patchReportingParty(rp)   // PATCH if existing
              : usersService.postNewReportingParty(rp) // POST if new
          )
        );

        success('Reporting party changes saved');

        // reload reporters to refresh UI
        await reloadReportersFromServer(selectedReport!.id);

        if (typeof numberOfChanges === 'number' && numberOfChanges > 0) {
          updateNumberOfChanges(-numberOfChanges);
        }
      } catch (err) {
        error('Error while saving Reporting Parties');
      }
    }

    if (reportersToRemove?.length) {
      const deleteReportersPromises = reportersToRemove.map((id: number) =>
        usersService.deleteReporter(`${id}`)
      );
      try {
        await Promise.all(deleteReportersPromises);
        success('Reporters deleted successfully');
        await reloadReportersFromServer(selectedReport!.id);
      } catch (err) {
        error('Error while deleting reporters');
      }
    }

    // if (formState.dirtyFields['teamMembers']) {
    //   const filteredArray = Object.keys(teamMembersWatchValue)
    //       ?.map(key => teamMembersWatchValue[key])
    //       .filter(
    //           (userA: IUserProfile) =>
    //               !teamMembers?.some((userB: IUserProfile) => userA.id === userB.id),
    //       )

    //   const arrayToPatch = Object.keys(teamMembersWatchValue)
    //       ?.map(key => teamMembersWatchValue[key])
    //       .filter((userA: IUserProfile) =>
    //           teamMembers?.some((userB: IUserProfile) => userA.id === userB.id),
    //       )

    //   const promisesToPatch = arrayToPatch?.map((user: IUserProfile) => {
    //     return usersService.patchUserToTeam({
    //       investigator: user.reportAssingId,
    //       report: selectedReport?.id as number,
    //       access: user?.access_role?.length > 0 ? user?.access_role : usersReportAccess.CAN_VIEW,
    //       role: user?.case_role?.length > 0 ? user?.case_role : usersReportRoles.TEAM_MEMBER,
    //       message: `Added to team on report: ${selectedReport?.uuid}`,
    //     })
    //   })

    //   const promises = filteredArray?.map((user: IUserProfile) => {
    //     return usersService.postUserToTeam({
    //       investigator: user.id,
    //       report: selectedReport?.id as number,
    //       access: user?.access_role?.length > 0 ? user?.access_role : usersReportAccess.CAN_VIEW,
    //       role: user?.case_role?.length > 0 ? user?.case_role : usersReportRoles.TEAM_MEMBER,
    //       message: `Added to team on report: ${selectedReport?.uuid}`,
    //     })
    //   })

    //   if (teamMembersToRemove?.length > 0) {
    //     const promisesToDelete = teamMembersToRemove?.map(async userId => {
    //       return usersService.removeTeamMember(userId)
    //     })

    //     try {
    //       const deletedTeamMembers = await Promise.all(promisesToDelete)
    //       success('Team members removed successfully')
    //     } catch (err) {
    //       error('Error while removing team members');
    //     }
    //   }

    //   try {
    //     const addedTeamMembers = await Promise.all(promises)
    //     alert('Team members added successfully');
    //   } catch (err) {
    //     error('Error while adding team members')
    //   }

    //   try {
    //     const patchedTeamMembers = await Promise.all(promisesToPatch)
    //     success('Team members patched successfully');
    //   } catch (err) {
    //     error('Error while patching team members');
    //   }
    // }

    if (formState.dirtyFields['teamMembers']) {
      const teamMemberValues = Object.values(teamMembersWatchValue || {}) as IUserProfile[];

      const filteredArray: IUserProfile[] = teamMemberValues.filter(
        (userA) => !teamMembers?.some((userB) => userA.id === userB.id)
      );

      const arrayToPatch: IUserProfile[] = teamMemberValues.filter((userA) => {
        const existing = teamMembers?.find((userB) => userA.id === userB.id);
        if (!existing) return false;

        const roleChanged = userA.case_role !== existing.case_role;
        const accessChanged = userA.access_role !== existing.access_role;

        return roleChanged || accessChanged;
      });

      let didAdd = false;
      let didPatch = false;
      let didDelete = false;

      // DELETE — only valid IDs
      if (Array.isArray(teamMembersToRemove) && teamMembersToRemove.some((id) => Number(id) > 0)) {
        try {
          await Promise.all(
            teamMembersToRemove.map((id) => usersService.removeTeamMember(id))
          );
          didDelete = true;
          await dispatch(getReportTeam());
        } catch {
          console.warn('Skipped invalid team delete');
        }
      }

      // ADD — ensure IDs exist
      if (filteredArray.length > 0) {
        try {
          await Promise.all(
            filteredArray
              .filter((user) => !!user.id)
              .map((user) =>
                usersService.postUserToTeam({
                  investigator: user.id!,
                  report: selectedReport!.id!,
                  access: user.access_role || usersReportAccess.CAN_VIEW,
                  role: user.case_role || usersReportRoles.TEAM_MEMBER,
                  message: `Added to team on report: ${selectedReport?.uuid}`,
                })
              )
          );
          didAdd = true;
          await dispatch(getReportTeam());
        } catch {
          error('Error while adding team members');
        }
      }

      // PATCH — only when reportAssingId is valid
      if (arrayToPatch.length > 0) {
        try {
          await Promise.all(
            arrayToPatch
              .filter((user) => !!user.reportAssingId)
              .map((user) =>
                usersService.patchUserToTeam({
                  investigator: user.reportAssingId!,
                  report: selectedReport!.id!,
                  access: user.access_role || usersReportAccess.CAN_VIEW,
                  role: user.case_role || usersReportRoles.TEAM_MEMBER,
                  message: `Updated role/access on report: ${selectedReport?.uuid}`,
                })
              )
          );
          didPatch = true;
          await dispatch(getReportTeam());
        } catch {
          error('Error while patching team members');
        }
      }

      if (didAdd || didPatch || didDelete) {
        if (didAdd) success('Team member added successfully');
        if (didPatch) success('Team member updated successfully');
        if (didDelete) success('Team member removed successfully');
      }

      // Clear removed array for next save
      setTeamMembersToRemove([]);
    }


    finalResponse = {
      ...finalResponse,
      ...(subjects.length > 0 && { subjects: subjects }),
      ...(victims.length > 0 && { victims: victims }),
      ...(reportingParties.length > 0 && { reportingParties: reportingParties }),
    }

    const { caseStatusMessage } = getValues()
    if (caseStatusMessage) {
      dispatch(postCaseStatusMessage({ description: caseStatusMessage }))
    }

    // eslint-disable-next-line
    // console.log('FINAL', finalResponse)
    success('Changes saved')
    if (!selectedReport?.id) return;

    const updatedReport = await reportsService.getCaseById(selectedReport.id);
    dispatch({
      type: 'reports/setSelectedReport',
      payload: {
        ...selectedReport,
        ...updatedReport,
        victims: updatedReport?.victims ?? selectedReport?.victims,
        subjects: updatedReport?.subjects ?? selectedReport?.subjects,
        reporters: updatedReport?.reporters ?? selectedReport?.reporters,
        report_status: updatedReport?.report_status ?? selectedReport?.report_status,
      },
    });

    // 🧩 Ensure team list reloads properly
    await dispatch(getReportTeam());

    oshaChangesCount.current = 0
    setNumberOfChanges(0)
    setOpenModalAreYouSure(false)
  }

  const discardChangesLogic = () => {
    for (const subjectId in subjectsFunctions) {
      removeSubject(subjectId)
    }

    for (const victimId in victimsFunctions) {
      removeVictim(victimId)
    }

    for (const reportingPartyId in reportingPartyFunctions) {
      removeReportingParty(reportingPartyId)
    }

    reset()
    success('Changes discarded');
  }

  const [showPrompt, confirmNavigation, cancelNavigation, justClosePrompt] = useCallbackPrompt(
      openModalAreYouSure,
      discardChangesLogic,
      saveEditsLogic,
  )

  const formMethods = useForm<ICaseOverviewForm>({
    defaultValues: constants.formState,
    resolver: vestResolver(formValidation),
    mode: 'onChange',
    shouldFocusError: false,
  })
  const { control, register, formState, reset, getValues, unregister, watch, setValue } =
      formMethods

  const { dirtyFields } = formState
  const changesNumber = Object.keys(dirtyFields).length

  const teamMembersWatchValue = watch('teamMembers')

  const updateNumberOfChanges = (newChanges: number, whoIsUpdating = '') => {
    const stateVariables: { [key: string]: any } = {
      'subject:': setTrackSubjectChanges,
      'victims:': setTrackVictimsChanges,
      'reportingParty:': setTrackReportingPartyChanges,
    }

    const setStateVariable = stateVariables[whoIsUpdating]

    if (setStateVariable) {
      setStateVariable((prev: { [x: string]: number }) => {
        return {
          ...prev,
          [whoIsUpdating]: prev[whoIsUpdating] + newChanges,
        }
      })
    }

    dispatch(addChange({ value: newChanges }))
    setNumberOfChanges(prev => {
      if (prev + newChanges < 0) {
        return 0
      }
      return prev + newChanges
    })
    setOpenModalAreYouSure(prev => prev || numberOfChanges + newChanges > 0)

    setChanges(changesNumber)
  }

  useEffect(() => {
    dispatch(getOrganizationUsers({ searchValue: searchUser, excludeLoggedUser: true, onlyAssignable: false}))
  }, [])

  const [oshaQuestions, setOshaQuestions] = useState<any[]>([])
  const [oshaAnswers, setOshaAnswers] = useState<any[]>([])
  const [defaultOshaAnswers, setDefaultOshaAnswers] = useState<any[]>([])
  const [updateOshaAnswers, setUpdateOshaAnswers] = useState<boolean>(false)
  const oshaChangesCount = useRef(0)

  const currentOshaType = useMemo(() => {
    const answer = findItemByUuid(oshaAnswers, caseOverviewConstants.oshaViolenceTypeQuestionUuid)
    const selectedOptionId = answer?.options?.[0]
    return Object.entries(caseOverviewConstants.oshaTypeToOptionId).find(([, id]) => id === selectedOptionId)?.[0] || ''
  }, [oshaAnswers])
  const getOshaAnswers = async (reportId: number, oshaDefaultAnswers: any[]) => {
    try {
      const { data: oshaAnswersResponse } = await reportsService.getAnswersToCaseTypeQuestions(
          reportId,
          'osha',
      )

      if (oshaAnswersResponse.length > 0) {
        setUpdateOshaAnswers(true)
      }

      const updatedAnswers1 = updateFunction(oshaAnswersResponse, oshaDefaultAnswers)

      if (defaultOshaAnswers.length === 0) {
        setDefaultOshaAnswers(_.cloneDeep(updatedAnswers1))
      }
      setOshaAnswersUpdated(true)
      setOshaAnswers(updatedAnswers1)
    } catch (err) {
      error('Error while fetching OSHA answers');
      // console.error('Error while fetching OSHA answers', err)
    }
  }

  const updateFunction = (arrayOfQuestions: any[], answers: any[]) => {
    let updatedAnswers = _.cloneDeep(answers)

    arrayOfQuestions.forEach(element => {
      if (
          element?.question?.variant.type === 'LOGICAL' ||
          element?.question?.variant.type === 'NUMBER'
      ) {
        updatedAnswers = updateAnswersText(
            updatedAnswers,
            element?.question?.uuid,
            element?.text,
            element?.id,
        )
      } else {
        updatedAnswers = updateAnswersOptions(
            updatedAnswers,
            element?.question?.uuid,
            element?.answers[0]?.question_option?.id
                ? [element?.answers[0]?.question_option?.id]
                : [],
            element?.id,
        )
      }

      if (element?.subanswers?.length > 0) {
        updatedAnswers = updateFunction(element?.subanswers, updatedAnswers)
      }
    })

    return updatedAnswers
  }
  const getOshaQuestions = async (reportId: number) => {
    try {
      const { data } = await reportsService.getCaseTypeQuestions({
        caseId: `${reportId}`,
        caseType: 'osha',
      })

      setOshaQuestions(data)

      const defaultAnswers = data
          ?.map(question => {
            return transformStructure(question)
          })
          .flat(1)

      if (selectedReport) {
        getOshaAnswers(selectedReport?.id, _.cloneDeep(defaultAnswers))
        return
      }
      setOshaAnswers(defaultAnswers)
    } catch (err) {
      error('Error while fetching OSHA questions');
      // console.log('Eror:', err)
    }
  }

  // const renderedOshaQuestions = useMemo(() => {
  //   const oshaQuestionsToRender = oshaQuestions?.map((question: IQuestionV2) => {
  //     return oshaQuestionParser(question, oshaAnswers, setOshaAnswers, !userEditAccess)
  //   })
  //   setHaveQuestionsBeenRendered(true)
  //   return oshaQuestionsToRender
  // }, [oshaQuestions, oshaAnswers])

  const renderedOshaQuestions = useMemo(() => {
  return oshaQuestions?.map((q: IQuestionV2, idx: number) => (
    <React.Fragment key={q?.uuid ?? q?.id ?? idx}>
      {oshaQuestionParser(q, oshaAnswers, setOshaAnswers, !userEditAccess)}
    </React.Fragment>
  ));
}, [oshaQuestions, oshaAnswers, userEditAccess]);

  const countChangesInOshaAnswers = (answers: any[]) => {
    answers?.forEach((answer: MainObject) => {
      const item = findItemByUuid(defaultOshaAnswers, answer?.uuid)
      if (item) {
        const differences = diff(item, answer)
        const changesCount = differences?.length || 0
        updateNumberOfChanges(changesCount - oshaChangesCount.current)
        oshaChangesCount.current = changesCount
      }
    })
  }

  useEffect(() => {
    if (oshaAnswers?.length > 0 && defaultOshaAnswers?.length > 0) {
      countChangesInOshaAnswers(oshaAnswers)
    }
  }, [oshaAnswers, defaultOshaAnswers])

  useEffect(() => {
    if (selectedReport) {
      getMessages()
      getOshaQuestions(selectedReport.id)
      const newDefaultValues = {
        ...constants.formState,
        summary: selectedReport.summary,
        attorney: selectedReport.attorney,
        tier_level: selectedReport.tier_level,
        name: selectedReport.name,
      }
      reset(newDefaultValues)
      if (!teamMembers) {
        dispatch(getReportTeam())
      }
      selectedReport.victims?.forEach((victim: any) => {
        if (Object.keys(victimsFunctions).length === 0) {
          addVictimFormHandler({
            victim: {
              person_type: victim.person_type,
              full_name: victim.full_name,
              description: victim.description,
              image: victim.image,
            },
            custom_fields: victim.custom_fields,
            id: victim.id,
          } as IVictimDTO)
        }
      })
      selectedReport.subjects?.forEach((subject: any) => {
        if (Object.keys(subjectsFunctions).length === 0) {
          addPersonFormHandler({
            subject: {
              person_type: subject.person_type,
              full_name: subject.full_name,
              description: subject.description,
              image: subject.image,
            },
            custom_fields: subject.custom_fields,
            id: subject.id,
          } as ISubjectDTO)
        }
      })
      // selectedReport.reporters?.forEach((reporter: any) => {
      //   const defaultValueBasedOnType = {
      //     ...ReportingPartyConstants.defaulfFormValues[reporter.person_type],
      //   }
      //   Object.keys(ReportingPartyConstants.defaulfFormValues[reporter.person_type]).forEach(
      //       key => {
      //         defaultValueBasedOnType[key] = reporter[key] ?? ''
      //       },
      //   )
      //   if (Object.keys(reportingPartyFunctions).length === 0) {
      //     addReportingPartyFormHandler({
      //       reporting_party: {
      //         ...defaultValueBasedOnType,
      //       },
      //       custom_fields: reporter.custom_fields,
      //       id: reporter.id,
      //     })
      //   }
      // })
      selectedReport.reporters?.forEach((reporter: any) => {
        if (Object.keys(reportingPartyFunctions).length === 0) {
          addReportingPartyFormHandler({
            reporting_party: {
              person_type: reporter.person_type,
              full_name: reporter.full_name,
              description: reporter.description,
              image: reporter.image,  // ✅ same as Subject
              report: selectedReport.id, // <-- Add the required report property
            },
            custom_fields: reporter.custom_fields,
            id: reporter.id,
          } as IReportingPartyDTO);
        }
      });
      // selectedReport.reporters?.forEach((reporter: any) => {
      //   if (Object.keys(reportingPartyFunctions).length === 0) {
      //     addReportingPartyFormHandler(toReportingPartyDTO(reporter));
      //   }
      // })

    }
  }, [selectedReport])

  useEffect(() => {
    if (teamMembers) {
      let newTeamMembersObject: { [key: number]: any } = {}
      teamMembers.forEach(member => {
        newTeamMembersObject[member?.id] = member
      })
      setSelectedUsers(newTeamMembersObject)
      setValue('teamMembers', newTeamMembersObject)
    }
  }, [teamMembers])

  useEffect(() => {
    if (changesNumber - changes == 0) return

    if (changesNumber !== changes) {
      updateNumberOfChanges(changesNumber - changes)
    }
  }, [formState])

  const { hash } = useLocation()

  useEffect(() => {
    if (!haveWeScrolledDowntoQuestion && haveQuestionsBeenRendered && oshaAnswersUpdated) {
      setHaveWeScrolledDowntoQuestion(true)
      // hash is "" when absent; also ignore a lone "#"
      if (!hash || hash === '#' || !hash.trim()) return;

      // remove leading '#' and decode in case the id has spaces or unicode
      const id = decodeURIComponent(hash.replace(/^#/, ''));

      if (!id) return; // avoids getElementById('') on Firefox

      const element = document.getElementById(id);

      const scrollEl = document.querySelector('.t-page-body')
      if (element && scrollEl) {
        scrollEl.scrollTo({
          behavior: 'smooth',
          top:
              element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 200,
        })
      }
    }
  })

  const getMessage = useCallback(
      (field: formTypes) => {
        if (!formState.errors[field]) return ''

        return formState.errors[field]!.message
      },
      [formState],
  )

  const onSubmit = (newUser: INewUser) => {
    dispatch(addNewUser({ newUser }))
  }

  const [subjectsCount, setSubjectCount] = useState(0)
  const [subjectsFunctions, setSubjectFunction] = useState<any>({})
  const [trackSubjectChanges, setTrackSubjectChanges] = useState<{ [key: string]: number }>({})
  const [subjectsToRemove, setSubjectsToRemove] = useState<number[]>([])
  // const addPersonFormHandler = (defaultValue?: ISubjectDTO) => {
  //   const newId = `${makeid()}`
  //   setSubjectCount(subjectsCount + 1)
  //   setSubjectFunction((prev: any) => {
  //     const findInPrevious = Object.keys(prev).find(key => {
  //       return prev[key]?.defaultValues?.id === defaultValue?.id
  //     })

  //     if (findInPrevious) {
  //       return prev
  //     }
  //     const newSubjectFunctions = {
  //       ...prev,
  //       [newId]: {
  //         submitFunction: () => {},
  //         defaultValues: defaultValue,
  //       },
  //     }
  //     return newSubjectFunctions
  //   })
  //   setTrackSubjectChanges((prev: any) => {
  //     const newSubjectFunctions = {
  //       ...prev,
  //       [newId]: 0,
  //     }
  //     return newSubjectFunctions
  //   })
  // }
  const addPersonFormHandler = (defaultValue?: ISubjectDTO) => {
    const newId = `${makeid()}`;
    setSubjectCount(c => c + 1);

    setSubjectFunction((prev: any) => {
      const foundKey = Object.keys(prev).find(key => {
        const existing = prev[key]?.defaultValues;
        return (
          (defaultValue?.id && existing?.id === defaultValue.id) ||
          (!defaultValue?.id &&
            existing?.subject?.full_name &&
            defaultValue?.subject?.full_name &&
            norm(existing.subject.full_name) === norm(defaultValue.subject.full_name))
        );
      });
      if (foundKey) return prev;

      return {
        ...prev,
        [newId]: { submitFunction: () => {}, defaultValues: defaultValue },
      };
    });

    setTrackSubjectChanges(prev => ({ ...prev, [newId]: 0 }));
  };

  const removeSubject = (id: string) => {
    updateNumberOfChanges(-trackSubjectChanges[id])
    setTrackSubjectChanges((prev: { [x: string]: any }) => {
      const { [id]: _, ...newObj } = prev
      return newObj
    })

    subjectsFunctions[id]?.defaultValues?.id &&
    setSubjectsToRemove(prev => [...prev, subjectsFunctions[id]?.defaultValues?.id])

    setSubjectFunction((prev: { [x: string]: any }) => {
      const { [id]: _, ...newObj } = prev
      return newObj
    })
  }

  const [victimsCount, setVictimsCount] = useState(0)
  const [victimsFunctions, setVictimsFunction] = useState<any>({})
  const [trackVictimsChanges, setTrackVictimsChanges] = useState<{ [key: string]: number }>({})
  const [victimsToRemove, setVictimsToRemove] = useState<number[]>([])
  const addVictimFormHandler = (defaultValue?: IVictimDTO) => {
    const newId = `${makeid()}`;
    setVictimsCount(victimsCount + 1);
    setVictimsFunction((prev: any) => {
      const findInPrevious = Object.keys(prev).find(key => {
        const existing = prev[key]?.defaultValues;
        return (
          (defaultValue?.id && existing?.id === defaultValue.id) ||
          (!defaultValue?.id &&
            existing?.victim?.full_name &&
            defaultValue?.victim?.full_name &&
            norm(existing.victim.full_name) === norm(defaultValue.victim.full_name))
        );
      });
      if (findInPrevious) return prev;

      return {
        ...prev,
        [newId]: { submitFunction: () => {}, defaultValues: defaultValue },
      };
    });

    setTrackVictimsChanges(prev => ({ ...prev, [newId]: 0 }));
  };

  // const addVictimFormHandler = (defaultValue?: IVictimDTO) => {
  //   const newId = `${makeid()}`
  //   setVictimsCount(victimsCount + 1)
  //   setVictimsFunction((prev: any) => {
  //     const findInPrevious = Object.keys(prev).find(key => {
  //       return prev[key]?.defaultValues?.id === defaultValue?.id
  //     })

  //     if (findInPrevious) {
  //       return prev
  //     }
  //     const newSubjectFunctions = {
  //       ...prev,
  //       [newId]: {
  //         submitFunction: () => {},
  //         defaultValues: defaultValue,
  //       },
  //     }
  //     return newSubjectFunctions
  //   })
  //   setTrackVictimsChanges((prev: any) => {
  //     const newSubjectFunctions = {
  //       ...prev,
  //       [newId]: 0,
  //     }
  //     return newSubjectFunctions
  //   })
  // }
  const removeVictim = (id: string) => {
    updateNumberOfChanges(-trackVictimsChanges[id])
    setTrackVictimsChanges((prev: { [x: string]: any }) => {
      const { [id]: _, ...newObj } = prev
      return newObj
    })
    victimsFunctions[id]?.defaultValues?.id &&
    setVictimsToRemove(prev => [...prev, victimsFunctions[id]?.defaultValues?.id])
    setVictimsFunction((prev: { [x: string]: any }) => {
      const { [id]: _, ...newObj } = prev
      return newObj
    })
  }
  const renderPersonForms = (personType: 'subject' | 'victim') => {
    const removeFunction = (key: string) => {
      return personType === 'victim' ? removeVictim(key) : removeSubject(key)
    }
    const submitFunctions = personType === 'victim' ? victimsFunctions : subjectsFunctions
    const forms: React.ReactNode[] = []
    // for (const key in submitFunctions) {
    //   forms.push(<DividerTAG key={`${Math.random()}`} />)
    //   forms.push(
    //       <Box
    //           sx={{ display: 'flex', width: '100%', justifyContent: 'end' }}
    //           key={`${Math.random()}`}
    //       >
    //         <RemoveButton
    //             tooltipMessage='Remove Person'
    //             removeFunctionHandler={() => {
    //               removeFunction(key)
    //             }}
    //             previewOnly={!userEditAccess}
    //         />
    //       </Box>,
    //   )
    //   forms.push()
    //   forms.push(
    //       <AddPersonForm
    //           updateNumberOfChanges={updateNumberOfChanges}
    //           submitFunctions={submitFunctions}
    //           submitFunctionName={key}
    //           key={key}
    //           defaultValue={submitFunctions[key]?.defaultValues}
    //           personType={personType}
    //           previewOnly={!userEditAccess}
    //       />,
    //   )
    // }
    for (const k in submitFunctions) {
      forms.push(<DividerTAG key={`${personType}-divider-${k}`} />);
      forms.push(
        <Box
          sx={{ display: 'flex', width: '100%', justifyContent: 'end' }}
          key={`${personType}-remove-box-${k}`}
        >
          <RemoveButton
            tooltipMessage="Remove Person"
            removeFunctionHandler={() => removeFunction(k)}
            previewOnly={!userEditAccess}
          />
        </Box>
      );

      forms.push(
        <AddPersonForm
          updateNumberOfChanges={updateNumberOfChanges}
          submitFunctions={submitFunctions}
          submitFunctionName={k}
          key={`${personType}-add-form-${k}`}
          defaultValue={submitFunctions[k]?.defaultValues}
          personType={personType}
          previewOnly={!userEditAccess}
        />
      );
    }

    return forms
  }

  const [reportingPartyCount, setReportingPartyCount] = useState(0)
  const [reportingPartyFunctions, setReportingPartyFunctions] = useState<any>({})
  const [reportersToRemove, setReportersToRemove] = useState<number[]>([])
  const [trackReportingPartyChanges, setTrackReportingPartyChanges] = useState<{
    [key: string]: number
  }>({})
  // const addReportingPartyFormHandler = (defaultValue?: IReportingPartyDTO) => {
  //   const newId = `${makeid()}`
  //   setReportingPartyCount(reportingPartyCount + 1)
  //   setReportingPartyFunctions((prev: any) => {
  //     const findInPrevious = Object.keys(prev).find(key => {
  //       return prev[key]?.defaultValues?.id === defaultValue?.id
  //     })

  //     if (findInPrevious) {
  //       return prev
  //     }
  //     const newSubjectFunctions = {
  //       ...prev,
  //       [newId]: {
  //         submitFunction: () => {},
  //         defaultValues: defaultValue,
  //       },
  //     }

  //     return newSubjectFunctions
  //   })
  //   setTrackReportingPartyChanges((prev: any) => {
  //     const newSubjectFunctions = {
  //       ...prev,
  //       [newId]: 0,
  //     }
  //     return newSubjectFunctions
  //   })
  // }
  const addReportingPartyFormHandler = (defaultValue?: IReportingPartyDTO) => {
    const newId = `${makeid()}`;
    setReportingPartyCount(c => c + 1);

    setReportingPartyFunctions((prev: any) => {
      const foundKey = Object.keys(prev).find(key => {
        const existing = prev[key]?.defaultValues;
        // Same record (server id) OR same name (case-insensitive) for unsaved rows
        return (
          (defaultValue?.id && existing?.id === defaultValue.id) ||
          (!defaultValue?.id &&
            existing?.reporting_party?.full_name &&
            defaultValue?.reporting_party?.full_name &&
            norm(String(existing.reporting_party.full_name)) === norm(String(defaultValue.reporting_party.full_name)))
        );
      });
      if (foundKey) return prev;

      return {
        ...prev,
        [newId]: { submitFunction: () => {}, defaultValues: defaultValue },
      };
    });

    setTrackReportingPartyChanges(prev => ({ ...prev, [newId]: 0 }));
  };


  const removeReportingParty = (id: string) => {
    updateNumberOfChanges(-trackReportingPartyChanges[id])
    setTrackReportingPartyChanges((prev: { [x: string]: any }) => {
      const { [id]: _, ...newObj } = prev
      return newObj
    })
    reportingPartyFunctions[id]?.defaultValues?.id &&
    setReportersToRemove(prev => [...prev, reportingPartyFunctions[id]?.defaultValues?.id])

    setReportingPartyFunctions((prev: { [x: string]: any }) => {
      const { [id]: _, ...newObj } = prev
      return newObj
    })
  }

  const renderReportingPartyForms = () => {
    const forms: React.ReactNode[] = []
    // for (const key in reportingPartyFunctions) {
    //   forms.push(<DividerTAG key={`${Math.random()}`} />)
    //   forms.push(
    //       <Box
    //           sx={{ display: 'flex', width: '100%', justifyContent: 'end' }}
    //           key={`${Math.random()}`}
    //       >
    //         <RemoveButton
    //             tooltipMessage='Remove Person'
    //             removeFunctionHandler={() => {
    //               removeReportingParty(key)
    //             }}
    //             previewOnly={!userEditAccess}
    //         />
    //       </Box>,
    //   )
    //   forms.push(
    //       <ReportingPartyForm
    //           updateNumberOfChanges={updateNumberOfChanges}
    //           submitFunctions={reportingPartyFunctions}
    //           submitFunctionName={key}
    //           key={key}
    //           defaultValue={reportingPartyFunctions[key]?.defaultValues}
    //           previewOnly={!userEditAccess}
    //       />,
    //   )
    // }
    for (const k in reportingPartyFunctions) {
      forms.push(<DividerTAG key={`reporting-divider-${k}`} />);

      forms.push(
        <Box
          sx={{ display: 'flex', width: '100%', justifyContent: 'end' }}
          key={`reporting-remove-box-${k}`}
        >
          <RemoveButton
            tooltipMessage="Remove Person"
            removeFunctionHandler={() => removeReportingParty(k)}
            previewOnly={!userEditAccess}
          />
        </Box>
      );

      forms.push(
        <ReportingPartyForm
          updateNumberOfChanges={updateNumberOfChanges}
          submitFunctions={reportingPartyFunctions}
          submitFunctionName={k}
          key={`reporting-add-form-${k}`}
          defaultValue={reportingPartyFunctions[k]?.defaultValues}
          previewOnly={!userEditAccess}
        />
      );
    }


    return forms
  }

  const functionsObject = useMemo(
      () => ({
        submitCaseTypes: () => {},
        submitLocationOfIncident: () => {},
        submitOshaViolenceType: () => {},
        submitNatureOfIncident: () => {},
        submitLawOrSecurityContacted: () => {},
      }),
      [],
  )
  const renderImportantDates = () => {
    return (
        <FormLayout>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1.4rem' }}>
            <Typography variant='labelBold'>Date Issue Was Reported</Typography>
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <CalendarMonthIcon />
              <Typography>
                {timeUtils.getFormatedDate(selectedReport ? selectedReport?.created_at : '')}
              </Typography>
            </Box>
            <DividerTAG />
            <Typography variant='labelBold'>Date Investigation Was Opened</Typography>
            <Box sx={{ display: 'flex', gap: '1rem' }}>
              <CalendarMonthIcon />
              <Typography>
                {timeUtils.getFormatedDate(selectedReport ? selectedReport?.updated_at : '')}
              </Typography>
            </Box>
            <DividerTAG />
          </Box>
        </FormLayout>
    )
  }

  const sections = [
    {
      id: 'name',
      title: 'Case Name',
      body: (
          <Box sx={{ width: '100%' }}>
            <TextareaInput
                label=''
                placeholder='Case Name'
                register={register}
                fieldName={'name'}
                error={getMessage('caseStatusMessage') as string}
                previewOnly={!userEditAccess}
            />
          </Box>
      ),
    },
    {
      id: 'caseStatus',
      title: 'Case Status',
      // cardAction: <CardAction options={[{ label: 'open', value: 'Open' }]} />,
      cardAction: (
          <Box
              sx={{
                width: '200px',
                height: '100%',
                backgroundColor: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
          >
            <Typography variant='bodyRegular'>{selectedReport?.report_status.status}</Typography>
          </Box>
      ),
    },
    {
      id: 'caseSummary',
      title: 'Case Summary',
      body: (
          <Box sx={{ width: '100%' }}>
            <TextareaInput
                label=''
                minRows={5}
                placeholder='Case Summary '
                register={register}
                fieldName={'summary'}
                error={getMessage('summary') as string}
                previewOnly={!userEditAccess}
            />
          </Box>
      ),
    },
    {
      id: 'clientPrivilege',
      title: 'Attorney / Client Privilege',
      cardAction: (
          <CardAction
              options={selectOptions.yesNo}
              controlRemote={control}
              fieldName={'attorney'}
              previewOnly={!userEditAccess}
          />
      ),
    },
    {
      id: 'tierLevel',
      title: 'Tier Level',
      cardAction: (
          <CardAction
              options={selectOptions.tierLevels}
              controlRemote={control}
              fieldName={'tier_level'}
              previewOnly={!userEditAccess}
          />
      ),
    },
    {
      id: 'team',
      title: 'Team',
      body: (
          <FormLayout>
            <TableTAG
                columns={constants.teamColumns({
                  control,
                  removeUserFromTeam,
                  previewOnly: !userEditAccess,
                })}
                pagination={false}
                rows={Object.keys(teamMembersWatchValue)?.map(key => teamMembersWatchValue[key])}
            />
            <Button
                variant='outlined'
                sx={{ color: colors.BLACK }}
                startIcon={<AddIcon />}
                onClick={() => {
                  setOpenUserModal(true)
                }}
                disabled={!userEditAccess}
            >
              <Typography variant='bodyRegular' color='inherit'>
                Invite New User
              </Typography>
            </Button>
          </FormLayout>
      ),
    },
    {
      id: 'caseTypes',
      title: 'Incident Type',
      body: (
          <CaseTypeForm
              updateNumberOfChanges={updateNumberOfChanges}
              submitFunctions={functionsObject}
              previewOnly={!userEditAccess}
          />
      ),
    },
    {
      id: 'importantDates',
      title: 'Important Dates',
      body: renderImportantDates(),
    },
    {
      id: 'subjects',
      title: 'Subjects',
      body: (
          <FormLayout>
            <Button
                variant='submitFormButton'
                startIcon={<AddIcon />}
                onClick={() => {
                  addPersonFormHandler()
                }}
                disabled={!userEditAccess}
            >
              <Typography variant='bodyBold'>Add Person</Typography>
            </Button>
            {renderPersonForms('subject')}
          </FormLayout>
      ),
    },
    {
      id: 'victims',
      title: 'Victims',
      body: (
          <FormLayout>
            <Button
                variant='submitFormButton'
                startIcon={<AddIcon />}
                onClick={() => {
                  addVictimFormHandler()
                }}
                disabled={!userEditAccess}
            >
              <Typography variant='bodyBold'>Add Person</Typography>
            </Button>
            {renderPersonForms('victim')}
          </FormLayout>
      ),
    },
    {
      id: 'reportingParty',
      title: 'Reporting Party',
      body: (
          <FormLayout>
            <Button
                variant='submitFormButton'
                startIcon={<AddIcon />}
                onClick={() => {
                  addReportingPartyFormHandler()
                }}
                disabled={!userEditAccess}
            >
              <Typography variant='bodyBold'>Add Person</Typography>
            </Button>
            {renderReportingPartyForms()}
          </FormLayout>
      ),
    },
    {
      id: 'workplaceInjury',
      title: 'Was There a Workplace Injury?',
      cardAction: (
          <CardAction
              options={selectOptions.yesNo}
              controlRemote={control}
              fieldName={'attorney'}
              previewOnly={!userEditAccess}
          />
      ),
    },
    {
      id: 'locationOfIncident',
      title: 'Location of Incident',
      body: (
          <SelectOneForm
              disabled={!userEditAccess}
              selectOptions={caseOverviewConstants.locationsOfIncidents}
              updateNumberOfChanges={updateNumberOfChanges}
              submitFunctions={functionsObject}
              fieldName='locationOfIncident'
          />
      ),
    },
    {
      id: 'osha',
      title: 'OSHA Workplace Violence Type',
      body: (
          <SelectOneForm
              disabled={!userEditAccess}
              selectOptions={caseOverviewConstants.oshaTypes}
              updateNumberOfChanges={updateNumberOfChanges}
              submitFunctions={functionsObject}
              fieldName='osha'
              testTest='submitOshaViolenceType'
              key={currentOshaType}
              defaultValues={{ osha: currentOshaType }}
          />
      ),
    },
    {
      id: 'natureOfIncident',
      title: 'Nature of Incident',
      body: (
          <SelectOneForm
              disabled={!userEditAccess}
              selectOptions={caseOverviewConstants.natureOfIncidentTypes}
              updateNumberOfChanges={updateNumberOfChanges}
              submitFunctions={functionsObject}
              fieldName='natureOfIncident'
          />
      ),
    },
    {
      id: 'lawEnforcement',
      title: 'Was Law Enforcement or Security Contacted?',
      body: (
          <SelectOneForm
              disabled={!userEditAccess}
              selectOptions={caseOverviewConstants.wasLawEnforcementOrSecurityContacted}
              updateNumberOfChanges={updateNumberOfChanges}
              submitFunctions={functionsObject}
              fieldName='lawEnforcement'
          />
      ),
    },
    {
      id: 'daysOffWork',
      title: 'Days of Lost Time Away From Work',
      cardAction: (
          <Box
              sx={{
                width: '200px',
                height: '100%',
                backgroundColor: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
          >
            <TextField></TextField>
          </Box>
      ),
    },
    {
      id: 'daysLostOnTransfer',
      title: 'Days of Lost Time On Job Transfer or Restriction',
      cardAction: (
          <Box
              sx={{
                width: '200px',
                height: '100%',
                backgroundColor: 'white',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
          >
            <TextField></TextField>
          </Box>
      ),
    },
  ]

  const renderSections = useMemo(() => {
    const sectionsToRender = [...sections]
    return sectionsToRender.map((section, index) => {
      const cls = classnames('marginTop-sections', {
        't-reporting-parties-card': section.id === 'reportingParty',
        't-subjects-card': section.id === 'subjects',
        't-victims-card': section.id === 'victims',
      })
      return (
          // <div id={section.id} key={`${section.id}${index}`} className={cls}>
            <div id={section.id} key={section.id} className={cls}>
            <CardTAG
                title={section.title}
                {...(section.cardAction ? { cardAction: section.cardAction } : {})}
            >
              {section.body && section.body}
            </CardTAG>
          </div>
      )
    })
  }, [sections])

  return (
      <Stack sx={{ mt: { xs: 2, md: 0 }, marginBottom: '7.2rem' }} spacing={2}>
        <Box sx={{ borderBottom: `2px solid ${colors.TAG_BLUE}`, paddingBottom: '1rem' }}>
          <Typography variant='h1' color={colors.TAG_BLUE}>
            Case Number: {selectedReport?.case_number}
          </Typography>
        </Box>
        {renderSections}
        {oshaQuestions.length > 0 && oshaAnswers && oshaAnswers.length > 0 && renderedOshaQuestions}
        <ModalTAG
            open={openUserModal}
            style={{ maxWidth: '900px', width: { xs: '95%', md: '70vw' } }}
        >
          <CardTAG
              title='Add User'
              closable={true}
              closeCard={() => {
                setOpenUserModal(false)
              }}
          >
            <FormLayout>
              <Box sx={{ display: 'flex', gap: '1rem', width: '100%', alignItems: 'end' }}>
                <SearchInput
                    label='User Search'
                    value={searchUser}
                    onValueChange={onSearchValueChange}
                    placeholder='Enter an EIN or name here to begin searching'
                />
                <Button
                    variant='outlined'
                    sx={{ borderRadius: '1rem', border: '1px solid black !important', height: '50%' }}
                >
                  <Typography
                      variant='bodyRegular'
                      sx={{ textTransform: 'none', color: colors.BLACK }}
                      onClick={() => {
                        getUsers()
                      }}
                  >
                    Search
                  </Typography>
                </Button>
              </Box>
              <DividerTAG />
              <Box sx={{ maxHeight: '40vh', overflow: 'hidden', paddingBottom: '1.8rem' }}>
                <TableTAG
                    columns={columns}
                    rows={organizationUsers}
                    onRowClick={handleUsersSelect}
                    selectedRows={getIdsFromUsers(selectedUsers)}
                    pagination={false}
                />
              </Box>
              <Box sx={{ width: '100%', display: 'flex', justifyContent: 'end' }}>
                <Button
                    variant='submitFormButton'
                    sx={{ width: '20%' }}
                    onClick={() => {
                      setOpenUserModal(false)
                    }}
                >
                  <Typography variant='bodyBold'>Return</Typography>
                </Button>
              </Box>
            </FormLayout>
          </CardTAG>
        </ModalTAG>
        {userEditAccess && (
            <SubmitCancelButtons
                submitButtonText={`Save \n ${resolveNumberOfChangesString(numberOfChanges)}`}
                submitHandler={saveEditsLogic}
                cancelButtonText='Cancel'
                cancelHandler={discardChangesLogic}
            />
        )}
        <ModalTAG open={showPrompt as boolean} style={{ width: 'auto' }}>
          <CardTAG
              title='Unsaved Edits'
              boxError={true}
              closable={true}
              closeCard={justClosePrompt as any}
          >
            <Typography variant='bodyBold' color={colors.TAG_RED}>
              You have {numberOfChanges} unsaved Edits
            </Typography>
            <Typography variant='bodyBold'>
              Would you like to save your changes before leaving this page?
            </Typography>
            <Box sx={{ display: 'flex', gap: '3rem', width: '100%', paddingTop: '3rem' }}>
              <Button
                  onClick={confirmNavigation as any}
                  variant='submitFormButton'
                  sx={{ backgroundColor: colors.GREEN, color: colors.WHITE, flex: '50%' }}
              >
                <Typography variant='bodyBold'>Save My Edits</Typography>
              </Button>
              <Button onClick={cancelNavigation as any} variant='outlined' sx={{ flex: '50%' }}>
                <Typography variant='bodyRegular' sx={{ whiteSpace: 'nowrap' }}>
                  Discard my Edits
                </Typography>
              </Button>
            </Box>
          </CardTAG>
        </ModalTAG>
      </Stack>
  )
}

export default DataPart
